import {
  DownOutlined,
  FileSyncOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Avatar, Popover } from "antd";
import { useAuth } from "authentication";
import SupportModal from "components/SupportModal/SupportModal";
import PropTypes from "prop-types";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ClientSelectedProgram } from "utils/Constant";
import { getCookieValue } from "utils/Storage";
import { USER_TYPES } from "utils/permissions/permissions.config";
import {
  getRoleForProgram,
  getUserType,
} from "utils/permissions/permissions.helpers";

const UserInfo = ({ dashboardView = false, stringToColour }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const { userSignOut } = useAuth();
  const history = useHistory();
  const [supportVisible, setSupportVisible] = useState(false);

  const gotoSetting = () => {
    history.push(`/administrations/global/changePassword/`);
  };

  const enlis_program = getCookieValue(ClientSelectedProgram);

  const userType = getUserType(authUser);
  const programRole = getRoleForProgram(authUser, enlis_program);
  const isTierUser = userType === USER_TYPES.TIER_USER;
  const isSuperAdmin = userType === USER_TYPES.SUPER_ADMIN;
  const isFacilityAdmin = userType === USER_TYPES.ADMIN;
  const isFacilityUser = userType === USER_TYPES.FACILITY_USER;

  const userMenuOptions = (
    <ul className="gx-user-popover">
      {/* <li onClick={gotoProfile}>
        <UserOutlined style={{ fontSize: "16px", color: "#6F42C1" }} />
        <span className="gx-user-menu">Profile</span>
      </li> */}
      <li
        onClick={(e) => {
          e.stopPropagation();
          setSupportVisible(true);
        }}
      >
        <FileSyncOutlined style={{ fontSize: "16px", color: "#377E21" }} />
        <span className="gx-user-menu">Help & Support</span>
      </li>
      <li
        onClick={(e) => {
          e.stopPropagation();
          gotoSetting();
        }}
      >
        <SettingOutlined style={{ fontSize: "16px", color: "#184673" }} />
        <span className="gx-user-menu">Change Password</span>
      </li>
      <li
        onClick={(e) => {
          e.stopPropagation();
          userSignOut();
        }}
      >
        <LogoutOutlined style={{ fontSize: "16px", color: "#DC3545" }} />
        <span className="gx-user-menu">Logout</span>
      </li>
    </ul>
  );

  return (
    <>
      <SupportModal
        visible={supportVisible}
        onClose={() => setSupportVisible(false)}
      />
      <Popover
        overlayClassName="gx-popover-horizantal"
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
      >
        <div className="gx-pointer flex-row items-center gx-enlis-user">
          {/* <Avatar src={"https://via.placeholder.com/150"} className="gx-avatar gx-pointer" alt=""/> */}
          <div
            className={`gx-mx-1 ${
              dashboardView
                ? "sm border-2 rounded-full border-white"
                : "gx-profile-banner-avatar"
            }`}
          >
            {/* <Avatar className="gx-size-40" src={userImg} /> */}
            {stringToColour(authUser?.username) && (
              <Avatar
                className={dashboardView ? "gx-size-35" : "gx-size-40"}
                style={{
                  backgroundColor: stringToColour(authUser?.username),
                  verticalAlign: "middle",
                }}
              >
                {authUser?.username?.charAt(0).toUpperCase()}
              </Avatar>
            )}
          </div>
          <div
            className="gx-media-body gx-task-item-content"
            style={{ display: "flex" }}
          >
            <div className="gx-task-item-content-left gx-d-lg-block gx-d-none">
              {/* {dashboardView === false && ( */}
              <>
                <span
                  // style={{textTransform: "capitalize"}}
                  className={`gx-text-no-truncate gx-task-item-title text-sm ${
                    dashboardView ? "text-white gx-mb-0" : ""
                  }`}
                >
                  {authUser.username?.length > 20
                    ? `${authUser.username.slice(0, 20)}...`
                    : authUser?.username}
                </span>
                <p className="gx-text-no-truncate gx-fs-sm gx-mb-0">
                  {isFacilityUser && (
                    <span className="text-xs capitalize italic font-medium">
                      {programRole || enlis_program || ""}
                    </span>
                  )}
                  {isSuperAdmin && (
                    <span className="text-xs capitalize italic font-medium">
                      Global Admin
                    </span>
                  )}
                  {isFacilityAdmin && (
                    <span className="text-xs capitalize italic font-medium">
                      Facility Admin
                    </span>
                  )}
                  {isTierUser && (
                    <span className="text-xs capitalize italic font-medium text-gray-200">
                      {authUser?.user_location_name} Tier User
                    </span>
                  )}
                </p>
              </>
              {/* )} */}
            </div>
            {/* <i className="icon icon-chevron-down gx-pl-1 gx-enlis-user-icon" /> */}
          </div>
          <DownOutlined className="gx-px-1 fs_14 gx-text-white" />
        </div>
      </Popover>
    </>
  );
};

UserInfo.propTypes = {
  stringToColour: PropTypes.func,
  dashboardView: PropTypes.bool,
};

export default UserInfo;
